import React from "react";

// Brand logo — uses /logo.jpeg from public.
export const Logo = ({ size = 24, withText = true, className = "" }) => {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <img
        src="/logo.jpeg"
        alt="Inove Tech"
        width={size}
        height={size}
        style={{ width: size, height: size }}
        className="rounded-[7px] object-cover border border-white/10"
        data-testid="brand-logo-mark"
      />
      {withText && (
        <span className="text-[#f5f5f7] font-medium tracking-tight text-[15px]">
          Inove Tech
        </span>
      )}
    </div>
  );
};
